<template>
<div>

    <div
        class="content-wrapper"
        style="min-height: 873px;"
    >
        <div>
            <!-- Main content -->
            <section class="content">
                <section class="col-lg-12 connectedSortable">

                    <div class="box">
                        <div class="box-header">
                            <h3 class="box-title"> {{ $t('TRANSACTION_CREDITCARD_LOG') }} </h3>
                        </div>
                        <!-- /.box-header -->
                        <div class="box-body">
                            <Transactions></Transactions>
                        </div>
                        <!-- /.box-body -->
                    </div>

                </section>
               
            </section>
        </div>
          <div style="clear:both;"></div>
</div>

</div>
</template>


<script>
export default {
    name: "without"
};
</script>



// WEBPACK FOOTER //
// src/components/Transactions/Without_request.vue